import { Alert, AlertDialog, Text } from "@vericus/cadmus-ui";

import { create, useModal } from "@ebay/nice-modal-react";

import * as styles from "./styles.css";

export interface StopRecordingConfirmModalProps {
  onConfirm: () => void;
  remainingAttempts: number;
}

export const StopRecordingConfirmModal = create<StopRecordingConfirmModalProps>(
  ({ onConfirm, remainingAttempts }: StopRecordingConfirmModalProps) => {
    const modal = useModal();

    const handleConfirm = () => {
      onConfirm();
      modal.hide();
    };

    return (
      <AlertDialog.Root open={modal.visible}>
        <AlertDialog.Content>
          <AlertDialog.Title asChild>
            <Text kind="headingFour">Stop recording early?</Text>
          </AlertDialog.Title>
          <AlertDialog.Description asChild>
            <Text kind="bodyLine" color="navy400">
              Are you sure you wish to continue? You will not be able to
              continue recording this attempt.
            </Text>
          </AlertDialog.Description>
          <Alert size="sm" severity="warning" className={styles.alertCentered}>
            You will have {remainingAttempts}{" "}
            {remainingAttempts === 1 ? "attempt" : "attempts"} left after this.
          </Alert>
          <AlertDialog.Actions
            style={{ gridTemplateColumns: "60px 60px", gap: 24 }}
          >
            <AlertDialog.Cancel onClick={modal.remove}>No</AlertDialog.Cancel>
            <AlertDialog.Action onClick={handleConfirm}>Yes</AlertDialog.Action>
          </AlertDialog.Actions>
        </AlertDialog.Content>
      </AlertDialog.Root>
    );
  }
);
